<template>
  <v-dialog 
  v-model="dialog" 
  content-class="c-dialog-border-13 dialog-mod"
  scrollable
  hide-overlay
  persistent
  :fullscreen="$vuetify.breakpoint.xs"
  max-width="1000px">

    <v-card v-if="dialog">
      
      <card @onClose="close" @onComplete="$emit('onComplete')" ref="card"></card>
    
    </v-card>

  </v-dialog>
</template>

<script>
import Card from './card'
export default {
  components: {
    Card
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    open () {
      this.dialog = true
      this.$nextTick(() => {
        this.$refs.card.open()
      })
    },
    close () {
      this.dialog = false
    }
  }
  
}
</script>

<style scoped lang="scss">
::v-deep .dialog-mod {
  height: 60vh;
}
</style>

